<template>
  <div>
       <div style="width:1300px;margin:0 auto;margin-top:80px;" id="v-content" :style="{minHeight:Height+'px'}">
        <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
              <p class="mt-2 mb-2">
                  <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                      销售同比
                  </span>

                  <span class="ml-5">
                      各公司每天销售同比数据(金额单位为:万元)
                  </span>
                   <span class="float-right span_close mr-2" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                   </span>
                </p>
                <div class="mb-2 mt-2" style="display:flex;align-items:center;">
                     <span class="ml-5 mr-2">
                       截至日期:
                     </span>
                     <date @changeDate="changeDate2($event)"/>
                     <span class="ml-5 mr-2">
                      最近多少天:
                     </span>
                       <select v-model="Nowday" style="width:50px;">
                                                          <option v-for="(item,index) in days" :key="index" :value="item" v-text="item" >
                                                              {{item}}
                                                          </option>
                          </select>
                     <button class="ml-5 bg-primary button_zi  hei" @click="getClerkSettlementQuery()">查询</button>
                </div>
              <div v-if="showPage">
                <table class="table table-striped table-hover sett"  ref="print">
                <thead>
                  <tr style="white-space:nowrap;">
                      <th class="text-center">日期</th>
                      <th class="text-center">周</th>
                      <th class="text-center" >医药商城</th>
                      <th class="text-center" >汉宁</th>
                      <th class="text-center" >工业</th>
                      <th class="text-center" >西药</th>
                      <th class="text-center" >新特药</th>
                      <th class="text-center" >药品</th>
                      <th class="text-center" >药材</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in tableData" :key="index" style="white-space:nowrap;">
                      <td class="text-center">
                          {{item.lDay}}
                          <br/>
                          <hr>
                          {{item.day}}
                           <br/>
                          <hr>
                          <span>
                           增长金额
                          </span>
                            <br/>
                          <hr>
                          <span style="color:green;">
                            增长率
                          </span>
                      </td>
                      <td class="text-center">
                          <span :class="{'weekColor':item.lWeek==6||item.lWeek==7}">
                           {{item.lWeek | Nowweek}}
                          </span>
                           <br/>
                          <hr>
                          <span :class="{'weekColor':item.week==6||item.week==7}">
                          {{item.week | Nowweek}}
                          </span>
                            <br/>
                          <hr>
                           <br/>
                          <hr>
                      </td>
                      <td class="text-center">
                          {{item.b0.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b0.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b0.growthTotalAmount}}
                          <br/>
                          <hr>
                           {{getgrowthTotalRate(item.b0.lTotalAmount,item.b0.totalAmount,item.b0.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b1.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b1.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b1.growthTotalAmount}}
                          <br/>
                          <hr>
                           {{getgrowthTotalRate(item.b1.lTotalAmount,item.b1.totalAmount,item.b1.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b2.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b2.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b2.growthTotalAmount}}
                          <br/>
                          <hr>
                           {{getgrowthTotalRate(item.b2.lTotalAmount,item.b2.totalAmount,item.b2.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b3.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b3.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b3.growthTotalAmount}}
                          <br/>
                          <hr>
                           {{getgrowthTotalRate(item.b3.lTotalAmount,item.b3.totalAmount,item.b3.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b4.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b4.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b4.growthTotalAmount}}
                          <br/>
                          <hr>
                           {{getgrowthTotalRate(item.b4.lTotalAmount,item.b4.totalAmount,item.b4.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b5.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b5.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b5.growthTotalAmount}}
                          <br/>
                          <hr>
                            {{getgrowthTotalRate(item.b5.lTotalAmount,item.b5.totalAmount,item.b5.growthTotalAmount)}}
                      </td>
                      <td class="text-center">
                          {{item.b6.lTotalAmount}}
                           <br/>
                          <hr>
                          {{item.b6.totalAmount}}
                            <br/>
                          <hr>
                          {{item.b6.growthTotalAmount}}
                          <br/>
                          <hr>
                            {{getgrowthTotalRate(item.b6.lTotalAmount,item.b6.totalAmount,item.b6.growthTotalAmount)}}
                      </td>
                      
                </tr>
                </tbody>
              </table>
              </div>

             <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

              </div>   

                     
            </div>
       </div>
           
            <div>
              <transition name="fade">
                <loading v-if="isLoading"></loading>
              </transition>
            </div>
   
  </div>
</template>
<script>
import Loading from '../../components/Loading1.vue'
import vPagination from "../../components/Pagination.vue";
import date from '../../components/Date.vue'
export default {
    name: 'SaleQuery',
    data() {
      return {
        Height:0,
        isLoading: false,
        tableData: [],
        showPage:true,
        Record: '',//总记录数
        Pcount: '',//总页数
        PageNo: 1, //当前页码
        totalNum:"",
        totalMoney:'',
        feeMoney:'',
        DateMoreThan:'',
        billCounts:'', //记录数    
        costAmounts:'',//金额
        Nowday:7,
        days:[],

            total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数
            // LastTop:30,

             dateType:'',
                cost:'',
                profit:'',
                counts:'',
      }
    },
    components: {
      vPagination,
      Loading,
      date,

    },
    computed: {},
    filters: {
      Nowweek:function(week) {
            switch(week){
                case 1:
                    return "周一"
                case 2:
                    return "周二"
                case 3:
                    return "周三"
                 case 4:
                    return "周四"
                 case 5:
                    return "周五"
                 case 6:
                    return "周六"
                 case 7:
                    return "周日"
            }
            
             
        } ,
   

     
   },
    methods: {

        getgrowthTotalRate(lTotalAmount,totalAmount,growthTotalAmount){
            var   growthTotalRate = 0;
                   if(totalAmount>0){
                    if(lTotalAmount>0){
                        growthTotalRate=growthTotalAmount/lTotalAmount;
                        growthTotalRate=growthTotalRate*100;
                        growthTotalRate=growthTotalRate.toFixed(2) +'%';
                    }else{
                         growthTotalRate="P";
                    }
                }else{
                         growthTotalRate="L";
                    
                }
                return   growthTotalRate
        },

        getNowdays(){
          const that = this;
          for(let i = 7;i<=30;i++){
              that.days.push(i);
          }
        },
          
           getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },

        changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.DateMoreThan=time;
  
      },
      getClerkSettlementQuery: async function (PageIndex) {
            this.isLoading=true;
            const {data: res} = await this.$http.post('Dls/getFun', {
              action:'Saledatebyday',
              obj: JSON.stringify({
                lastTop:this.Nowday,
                endDate:this.DateMoreThan,
              })
            })
            // console.log(res)
            if (res.isok) {
              const obj = res.data
              this.tableData = obj.rows
               if(this.tableData.length>0)
                        {
                            this.showPage=true;
                        }
                        else{
                            this.showPage =false;
                        }
              this.total = obj.pcount
              this.Pcount = obj.pcount
              this.Record = obj.record
              this.isLoading = false
         
            }
        
      },

     pagechange:function(currentPage){

           this.getClerkSettlementQuery(currentPage);
         
     },
     
      start_print() {
        this.$print(this.$refs.print);
      }

    },
     mounted(){
    this.Height = document.documentElement.clientHeight - 100;  
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}
  
    },
    created() {
          this.DateMoreThan=this.getDay1(1)
         this.getNowdays();
         this.getClerkSettlementQuery();
    }
  }
</script>
<style scoped>
  .table-hover > tbody > tr:hover {
    background-color: #dee2e6 !important;
  }
  .money{
      color:red;
      font-weight: 500;
  }
  .record{
      color:green;
      font-weight: 500;
  }
  .sett{
        width:1300px;
        table-layout:fixed;
       
  }
  .sett-td {

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

   -moz-text-overflow: ellipsis; 

}
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
 .autocut:hover
 {
     overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
  .hei{
    height:1.5rem;
  }
  .input_form-control { 
/* // display: block;  */
width: 5%; 
height: 25px; 
padding: 6px 12px; 
font-size: 14px; 
line-height: 1.428571429; 
color: #555555; 
vertical-align: middle; 
background-color: #ffffff; 
border: 1px solid #cccccc; 
border-radius: 4px; 
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075); 
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s; 
} 
.input_form-control:focus { 
border-color: #66afe9; 
outline: 0; 
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6); 
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
.weekColor{
    color:red;
}
</style>


// WEBPACK FOOTER //
// src/pages/manager/SalesYearonYear.vue